import { ArrowDownRight, ArrowUpRight, Minus } from "lucide-react";
import { formatDelta } from "./demandForecastCalendarUtils";

/**
 * Renders a period-over-period delta as a compact, color-coded pill.
 * @param delta - The percentage change, or null when there's no baseline.
 * @returns The delta pill, or null when delta is null.
 */
export function DeltaPill({ delta }: { delta: number | null }) {
  if (delta === null) {
    return null;
  }
  const trend = delta > 0 ? "up" : delta < 0 ? "down" : "flat";
  const TrendIcon =
    trend === "up" ? ArrowUpRight : trend === "down" ? ArrowDownRight : Minus;
  const tone =
    trend === "up"
      ? "bg-emerald-50 text-emerald-700"
      : trend === "down"
        ? "bg-destructive/10 text-destructive"
        : "bg-muted text-muted-foreground";

  return (
    <span
      className={`inline-flex w-fit items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium tabular-nums ${tone}`}
    >
      <TrendIcon className="h-3 w-3 shrink-0" />
      {formatDelta(delta)}
    </span>
  );
}
